import React, { useCallback, createRef } from 'react'
import FormatterIcon from './FormatterIcon';

const propTypes = {
};

export default function ImageFormatter({ editor, ...props }) {
  const inputImageRef = createRef();

  const getBase64 = useCallback((file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }, [])

  const addImage = useCallback(url => {
    if (url) {
      editor.chain().focus().setImage({ src: url }).run()
    }
  }, [editor])

  return <>
    <FormatterIcon {...props} onClick={() => inputImageRef ? inputImageRef.current.click() : null} />
    <input
      type="file"
      className='hidden'
      ref={inputImageRef}
      accept="image/*"
      onInput={event => {
        getBase64(event.target.files[0], image64 => {
          addImage(image64);
        })
      }}
    />
  </>
}

ImageFormatter.propTypes = propTypes
ImageFormatter.defaultProps = {}
